import React from "react";
import { View, Text, TextInput } from "ui";
import { styled } from "styles";

const MenuBar = () => {
  return (
    <View
      flex={1}
      bg="black"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={2}
      mb={3}
    >
      <View flexDirection="row" alignItems="center" justifyContent="center">
        <Image src={require("assets/logo.png")} />
        {/* <View mt={3}>
          <Text ml={2} fontSize={6} color="white">
            Auto
          </Text>
          <Text fontSize={6} color="primary">
            Memo
          </Text>
        </View> */}
      </View>
    </View>
  );
};

const Image = styled.img`
  max-width: 6rem;
  max-height: 6rem;
`;

export default MenuBar;



// WEBPACK FOOTER //
// ./src/components/MenuBar.tsx